const getCategory = state => state.category

export default {
    getCategory
}